Vendd.Scripts.load(function () {
 
    if ($('.header-template-one').length <= 0)
        return;

    toggleMobileMenu();

    if (!isTouch())
        stickyHeader();  

    initCallMeBack();
});

function stickyHeader() {

    var header = $('.header-region');
    var headerHeight = header.height();
    var menuHeight = ($('.region-area-three', header).height() + $('.region-area-zero', header).height());
    var eSatisfactionHeight;
    var criticalHeight;

    var spacer = $('.header-spacer');

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.region-area-three').outerHeight();


    $(window).scroll(function(event){
        didScroll = true;
    });
    
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {

        //if ($(window).width() < 1200)
        //    return;

        var st = $(this).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        eSatisfactionHeight = $('.esat-bar').height() || 0;
        criticalHeight = (headerHeight + eSatisfactionHeight) - menuHeight;

        if (st > lastScrollTop && st > navbarHeight) {
            header.addClass('sticky');
            spacer.height(headerHeight);

        } else {
            header.removeClass('sticky');
            spacer.height(0);
        }
        lastScrollTop = st;
    }
    
}

function menuEffect() {
    // Hide header on on scroll down

    var header = $('.header-region');
    var headerHeight = header.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > headerHeight) {
                // Scroll Down
                header.addClass('hidden');
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    header.removeClass('hidden');
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function toggleMobileMenu() {
    var $mainMenu = $(".main-menu-mobile");

    $('.js-mobile-btn, .js-close-canvas').on('click', function (e) {
        if($("html").hasClass("show-canvas")){
            $("html").removeClass("show-canvas");
            $('.site-overlay').hide().removeClass('visible');
        } else {
            $("html").addClass("show-canvas");
            setTimeout(function () {
                $('.site-overlay').fadeIn(300);
            }, 300);
        }
    });

    $('.site-overlay').on('click', function (e) {
        $("html").removeClass("show-canvas");
        $('.site-overlay').hide().removeClass('visible');
        //KV EDIT
        $('.x-main-menu-two .nav-1 > li.hovered').removeClass("hovered");
    });
}

function initCallMeBack() {

    if ($('.x-call-me-back-widget').length < 1)
        return;
    
    $('.call-me-back').click(function (e) {
        var url = $(this).data('url');
        $.fancybox.open({
            src: url,
            type: "iframe",
            toolbar: false,
            smallBtn: true,
            hash: null,
            baseClass: 'call-me-back-fancy',
            afterShow: function () {
                var $iframe = $('.fancybox-iframe').contents();
                $iframe.find('body').addClass('full');
            }
        });

    }); 
}

function calculateSearchHeight() {
    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1 || $(window).outerWidth() < 1440) return;

    var header = $('.header-region'), headerHeight, eSatisfactionHeight;

    headerHeight = header.height() - $('.region-area-three', header).height();
    eSatisfactionHeight = $('.esat-bar').height();

    searchOffset = headerHeight + eSatisfactionHeight;
    
    $('.x-elastic-results-list', $wrapper).css({ 'height': 'calc(100% - ' + searchOffset + 'px)', top: searchOffset });
}